

export function optDebugLog(...params: unknown[]) {
  if ((window as any).debug_log) {
    console.log('optDebugLog', ...params);
  }
}
